import {
  AdminprofileImage,
  CategoryCard,
  Navbar,
  Loader,
  Btn,
  AnimateSpin,
  InputField,
  Text,
  Pagination,
} from '../../components/index';
import Icons from '../../assets/icons';
import CategoryScreenFunction from './index.function.js';
import { fontSizes } from '../../constants/constants.js';
const SelectCategoryScreen = () => {
  const {
    handleFormSubmit,
    navigate,
    register,
    setValue,
    errors,
    isLoading,
    services,
    selectedCategoryId,
    setSelectedCategoryId,
    loadingToapi,
    TextWeight,
    totalItems,
    currentPage,
    totalPages,
    handlePageChange,
  } = CategoryScreenFunction();
  return (
    <div className='flex'>
      <Navbar />
      <form
        className='flex-1 flex flex-col h-screen'
        onSubmit={handleFormSubmit}
      >
        <div className='px-4 lg:px-12 pt-10'>
          <AdminprofileImage onBack={() => navigate('/')} />
          <Text
            text={'Project Name'}
            size={fontSizes.h30}
            weight={TextWeight.Raleway_Bold}
            color='text-black'
            isTruncate={false}
          />
          <div className='relative mt-2.5 2xl:mt-5'>
            <InputField
              type='text'
              name='projectName'
              placeholder='Project Name'
              {...register('projectName', {
                required: 'Project Name is required',
              })}
              onChange={(value) => setValue('projectName', value)}
              icon={Icons.DocIcon}
              iconStyle={'w-5 h-5 lg:h-6 lg:w-7 2xl:w-8 2xl:h-7'}
            />
            {errors.projectName && (
              <span style={{ color: 'red' }}>{errors.projectName.message}</span>
            )}
          </div>
        </div>
        <Text
          text={'Select Category'}
          size={fontSizes.h30}
          weight={TextWeight.Raleway_Bold}
          color='text-black'
          isTruncate={false}
          className={'px-4 lg:px-12 pt-5 sm:pt-8'}
        />
        <div className='flex-1 overflow-y-auto h-full hide-scrollbar px-4 lg:px-12 py-2 mt-6 sm:mt-10'>
          {isLoading ? (
            <AnimateSpin />
          ) : (
            <div className='grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-10'>
              {services?.categories?.map((category) => (
                <CategoryCard
                  key={category?._id}
                  cateCardtitle={category?.name}
                  cateCardImg={`${category?.image}`}
                  selectedIcon={Icons.categorySelectedIcon}
                  selected={selectedCategoryId === category?._id}
                  isPublished={category?.isPublished}
                  onSelect={() => setSelectedCategoryId(category?._id)}
                />
              ))}
            </div>
          )}
        </div>

        <div className='px-4 lg:px-12 pb-4 lg:pb-10 pt-2'>
          <div className='w-full flex justify-center'>
            {totalItems > 12 && (
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            )}
          </div>
          <Btn
            type={'submit'}
            isDisabled={!selectedCategoryId || loadingToapi}
            loading={loadingToapi}
            isprimary={false}
            weight={TextWeight.Raleway_SemiBold}
            textSize={fontSizes.h18}
            text={'Next'}
            color='text-white'
            hover={'hover:text-primary hover:bg-white hover:border-primary'}
            bgColor={'bg-primary border-transparent'}
            className={'mx-auto mb-4 sm:mb-7 lg:mb-10 mt-2'}
          />
        </div>
      </form>
    </div>
  );
};
export default SelectCategoryScreen;
